export const BANK_TRANSFER_DETAILS = Object.freeze({
  bankName: "Access Bank",
  accountNumber: "1547789250",
  accountName: "LABORHACK LIMITED",
});
